/**
 * QL-120 — value control for `__goal_type__` conditional-display rules.
 *
 * Shared by the flow editor and the PDF editor: a checkbox list of the
 * collection's goal types (labelled in the editor's language) plus an explicit
 * "No type" entry for goals whose type is still unchosen. The rule value is a
 * JSON array of goal-type ids — the same encoding multiselect answers use, so
 * every evaluator parses it with `parseMultiselectValue`.
 *
 * Ids no longer present in the collection are dropped silently once the list
 * has loaded (the platform editor does the same); the stored rule is untouched
 * until the designer saves.
 */

export const T = {
  en_GB: {
    noType: "No type",
    noGoalTypes: "This collection has no goal types configured.",
  },
  nb_NO: {
    noType: "Ingen type",
    noGoalTypes: "Denne samlingen har ingen måltyper konfigurert.",
  },
} as const;
